import Axios from 'axios'

import { ASSETS_PATH_BASE } from '@/config'

export const axiosForData = Axios.create({
  baseURL: ASSETS_PATH_BASE + 'data',
})
